import { Card, CardContent } from "@/components/ui/card";

const PAIRS = [
  [0, 5],
  [1, 6],
  [2, 7],
  [3, 8],
  [4, 9],
];

export const MirrorPanel = ({ activePair, onSelectPair, globalMirrorOn, onToggleGlobal }) => {
  return (
    <Card className="bg-[#131c2e]/90 border-slate-800 shadow-xl shadow-black/40">
      <CardContent className="p-5 sm:p-6 space-y-4">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <h3 className="font-heading text-lg sm:text-xl font-bold text-slate-100">
            Step 3 · Mirror Numbers
          </h3>
          <button
            type="button"
            data-testid="mirror-global-toggle"
            onClick={onToggleGlobal}
            className={`text-xs font-mono-digit uppercase tracking-wider px-3 py-2 rounded-lg border transition-all ${
              globalMirrorOn
                ? "bg-purple-500/20 border-purple-500/60 text-purple-200"
                : "bg-slate-800/60 border-slate-700 text-slate-400 hover:text-slate-200"
            }`}
          >
            {globalMirrorOn ? "Mirror ALL · ON" : "Mirror ALL · OFF"}
          </button>
        </div>

        <div className="grid grid-cols-5 gap-2">
          {PAIRS.map(([a, b]) => {
            const active = activePair === `${a}${b}`;
            return (
              <button
                key={`${a}${b}`}
                type="button"
                data-testid={`mirror-toggle-${a}${b}`}
                onClick={() => onSelectPair(`${a}${b}`)}
                className={`h-16 rounded-xl border flex items-center justify-center gap-2 font-mono-digit text-xl font-bold transition-all duration-150 hover:scale-[1.03] ${
                  active
                    ? "bg-purple-500/20 border-purple-500/70 text-purple-200 shadow-[0_0_18px_rgba(139,92,246,0.3)]"
                    : "bg-[#0b0f17] border-slate-800 text-slate-200 hover:border-slate-600"
                }`}
              >
                <span>{a}</span>
                <span className="text-slate-500 text-sm">↔</span>
                <span>{b}</span>
              </button>
            );
          })}
        </div>
        <p className="text-xs text-slate-500">
          Select a pair to swap every occurrence of that pair in candidate hits. Click a cell in the
          grid above to flip just that one.
        </p>
      </CardContent>
    </Card>
  );
};
